// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12y-6","colMin":"styles_colMin__vJGnQ"};